<div class="validation-project-resume-container">
  @if (model) {
    <ng-kitchen-validation-project-resume-table
      [model$]="validationProjectResumeWithoutInstallation.asObservable()"
      [loading$]="loading$"></ng-kitchen-validation-project-resume-table>
    <ng-kitchen-validation-project-resume-table
      [model$]="validationProjectResumeWithInstallation.asObservable()"
      [loading$]="loading$"></ng-kitchen-validation-project-resume-table>
  }
</div>
